import { TopToolbar } from "react-admin";
import { styled } from "@mui/system";

const CustomTopToolbar = styled(TopToolbar)(({ theme }) => ({
  alignItems: "center",
}));

export default CustomTopToolbar;
